<div class="p-1 pt-3">

  <a routerLink="/townships" class="btn btn-sm btn-outline-secondary mb-3">
    <i class="bi bi-chevron-left me-1"></i>Back to townships
  </a>

  @if (loading()) {
    <div class="text-muted py-4 text-center">
      <span class="spinner-border spinner-border-sm me-2" role="status"></span>Loading…
    </div>
  } @else if (error()) {
    <div class="alert alert-danger">{{ error() }}</div>
  } @else {
    @let t = township();
    @if (t) {

      <div class="d-flex align-items-center gap-2 mb-4">
        <h4 class="mb-0">{{ t.name }}</h4>
        <span class="badge bg-light text-dark border">{{ t.status }}</span>
      </div>

      @if (actionError()) {
        <div class="alert alert-danger">{{ actionError() }}</div>
      }

      <div class="row g-4">
        <!-- Details / edit -->
        <div class="col-lg-8">
          <div class="card mb-4">
            <div class="card-header fw-semibold"><i class="bi bi-pencil-square me-2"></i>Details</div>
            <div class="card-body">
              <div class="mb-3">
                <label for="name" class="form-label">Name</label>
                <input
                  id="name"
                  type="text"
                  class="form-control"
                  [ngModel]="name()"
                  (ngModelChange)="name.set($event)"
                >
              </div>
              <div class="mb-3">
                <label for="status" class="form-label">Status</label>
                <select
                  id="status"
                  class="form-select"
                  [ngModel]="status()"
                  (ngModelChange)="status.set($event)"
                >
                  @for (s of statuses; track s) {
                    <option [value]="s">{{ s }}</option>
                  }
                </select>
              </div>
              <button class="btn btn-primary" (click)="save()" [disabled]="saving()">
                @if (saving()) {
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                }
                Save
              </button>
            </div>
          </div>
        </div>

        <!-- Metadata / danger zone -->
        <div class="col-lg-4">
          <div class="card mb-4">
            <div class="card-header fw-semibold"><i class="bi bi-info-circle me-2"></i>Metadata</div>
            <ul class="list-group list-group-flush small">
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">Created</span><span>{{ t.created | date:'d MMM y, HH:mm' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">Updated</span>
                <span>{{ t.updated ? (t.updated | date:'d MMM y, HH:mm') : '—' }}</span>
              </li>
              <li class="list-group-item d-flex justify-content-between">
                <span class="text-muted">ID</span><span class="font-monospace">{{ t.id }}</span>
              </li>
            </ul>
          </div>

          <div class="card border-danger mb-4">
            <div class="card-header fw-semibold text-danger"><i class="bi bi-exclamation-triangle me-2"></i>Danger zone</div>
            <div class="card-body">
              <button class="btn btn-outline-danger" (click)="remove()" [disabled]="deleting()">
                @if (deleting()) {
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                }
                <i class="bi bi-trash me-1"></i>Delete township
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
